import React, { useCallback } from 'react';
import { IconCirclePlus } from 'src/content/icons';
import { strings } from 'src/localization';
import css from './AddVehicleCard.module.scss';
import classNames from 'classnames';


export interface IProps {
    // The selected flag is used for styling
    selected?: boolean;
    theme: string;
    // The clickVehicle prop will receive a string with the id of the vehicle clicked
    clickVehicle: (id: string, e: any) => void;
}

const AddVehicleCard = (props: IProps) => {
    // If selected include the selected class for styling
    const classes = classNames(
        css.vehicle,
        {
            [css.selected]: (props.selected),
        },
    );
    const AddVehicleId = 'AddVehicle';
    const keyFunction = useCallback((e) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.clickVehicle(AddVehicleId, e);
        }
    }, [props.clickVehicle]);

    let CSSh4VehCard = css.h4VehCard;
    let CSSplusIcon = css.plusIcon;
    if (props.theme === 'bmw') {
        CSSh4VehCard = css.h4VehCardBMW;
        CSSplusIcon = css.plusIconAlt;
    }

    if (props.theme === 'chevrolet') {
        CSSh4VehCard = css.h4VehCardCV;
        CSSplusIcon = css.plusIconCV;
    }

    if (props.theme === 'buick') {
        CSSh4VehCard = css.h4VehCardBuick;
        CSSplusIcon = css.plusIconBuick;
    }

    if (props.theme === 'ford') {
        CSSh4VehCard = css.h4VehCardFord;
        CSSplusIcon = css.plusIconAlt;
    }

    return (
        <div id='AddVehicleCard'
            className={classes}
            onClick={(e) => props.clickVehicle(AddVehicleId, e)}
            onKeyDown={(e) => keyFunction(e)}
            tabIndex={0}>
            <IconCirclePlus className={CSSplusIcon} />
            <div className={css.addVehicle}>
                <h4 className={CSSh4VehCard}>{strings.AddNewVehicle}</h4>
            </div>
        </div>
    );
};
export default AddVehicleCard;
